
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g2wt_45HtqsV3V0au6h_45eCyqyh5kp5_45CMI6Rw78JkksqkAMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexdrynGrrEJuCG7x42W04SN3v7PGLr0aHSxsNAUSsoNa0Meta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchEGeVmuRqTjNwcKRGGO_45rVISJ9QoOE1EdCTrnhsCAlOAMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index5xAQ0Jzk2M_tOZl5xGveulBIdK_45AL9Kz3lHO32btuygMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93W1CyHxFDAvq6bShqUKGrE_fDPaSIAfQy6_H1M9XoN_45AMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexoZyvsnYzS44ioj8uNgZeckQG8E3qdjU_45co3fq93WNV4Meta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93GwGBo5TSLjfUXtKikkKZH0HGz4mXsMgJCd49D_NwFSoMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexDCKucOHzXwDXLz43kpCqRw3IB0UvOudnPGVBKhHber4Meta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Y00kIvbAAr2CYcWOH3VwY3qFxAmr2LqAKwZzZrIjsUgMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexCFqUsRSRT3G1b_45yQxnyTiOiDL17WK7pIVZj2UJZIazUMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexBNrK_45Ih970s7otHWoXy_8qyEDEy2sn3a7is62N6HBrgMeta } from "/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexoZyvsnYzS44ioj8uNgZeckQG8E3qdjU_45co3fq93WNV4Meta || {},
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexDCKucOHzXwDXLz43kpCqRw3IB0UvOudnPGVBKhHber4Meta || {},
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexCFqUsRSRT3G1b_45yQxnyTiOiDL17WK7pIVZj2UJZIazUMeta || {},
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexBNrK_45Ih970s7otHWoXy_8qyEDEy2sn3a7is62N6HBrgMeta || {},
    component: () => import("/codebuild/output/src3849247763/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]